<template>
  
  <v-card>
    
    <v-card-text>
      <v-col>
        <p class="text-h5">{{$t("Updates")}}</p>
      </v-col>
      <v-col>
        <v-row>
          <v-col cols="12">
            <v-btn
              color="#196619"
              dark
              @click="proceedUpdate"
              :loading="loading"
            >
              {{$t('update')}}
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              height="600px"
              :label="$t('Output')"
              :value="textoutput"
              outlined
            >
              
            </v-textarea>
          </v-col>
        </v-row>
      </v-col>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
    name: "updates",

    data() {
      return {
        loading: false,
        textoutput: '',
        stream: null,

      }
    },
                  
    methods: {
      async proceedUpdate() {
         try {
          this.textoutput = ''
          this.loading = true
          this.stream = await this.$http.post("/updates")
          if (this.stream.status != 200) {
            this.$emit('alertMsg', { type: 'error', text: this.stream.statusText +"\n"})
            this.loading = false
            return
          } 
          this.textoutput += this.stream.data
                 
        } catch (e) {
          this.$emit('alertMsg', { type: 'error', text: e.message +"\n"})
          console.log(e)
          this.loading = false
        } finally {
          this.loading = false
        }

      }
    }

    




}
</script>

<style>

</style>
